function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54 35c.088 6.627-11.641 12-26 12-8.53 0-12.006-4.446-20.842-4.824C2.993 41.996 1.535 37.486 2 35c1.218-6.514 11.657-12.692 26-12 4.65.224 6.774 2.912 10.79 3.219C49 27 53.942 30.676 54 35z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.235 37c3.011-2.258 4.58-2.08 7.765 0l3.235-1.488v3.43L15 37c-3.114 1.798-4.715 2.065-7.765 0zM35 40c4-4 10.594 2 14-1M35 36c4-4 10.594 2 14-1M35 32c4-4 10.594 2 14-1M19.235 31c3.011-2.258 4.58-2.08 7.765 0l3.235-1.488v3.43L27 31c-3.115 1.798-4.715 2.065-7.765 0z"
}));

var SvgPond = function SvgPond(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pond.75329e9e.svg";
export { ForwardRef as ReactComponent };